var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C3C50",
    d: "M98 10h-4c-1.104 0-9 4.896-9 6H74v26h11c0 1.104 7.896 6 9 6h4a2 2 0 0 0 2-1.999V12a2 2 0 0 0-2-2zM69.979 48.569c.006 2.149.015 3.432.021 3.432v-3l-.021-.432zM12 58a2.003 2.003 0 0 0 2 2h8.957c1.812 2.618 4.459 6 6.043 6h2c5.523 0 10 4.479 10 10.001V96a4 4 0 0 0 4 4h13a4 4 0 0 0 4-4V66h5c2.209 0 3-.79 3-2.999v-11H12V58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEEEF",
    d: "M70 0H12C5.373 0 0 5.373 0 12v28c0 6.628 5.373 12.001 12 12.001h58c-.051 0-.07-52.052 0-52.001z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8CBCB",
    d: "M27 15h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#23475F",
    d: "M72 0h-2v52h2a2 2 0 0 0 2-2.001V2a2 2 0 0 0-2-2zm13 16h-3v26h3V16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M54 12a6 6 0 1 0 6 6c0-3.313-2.688-6-6-6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B39",
    d: "M54 14a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BD9C",
    d: "M37 14H13a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C3C50",
    d: "M28 13h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#23475F",
    d: "M26 13h-2v10h2V13z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCC4C8",
    d: "M0 36v4c0 6.628 5.373 12.001 12 12.001h58c-.02 0-.033-7.074-.041-16L0 36z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#23475F",
    d: "M98 10h-4c-.176 0-.538.135-1 .349v37.302c.462.214.824.349 1 .349h4a2 2 0 0 0 2-1.999V12a2 2 0 0 0-2-2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A185",
    d: "M20 21v-5.722c-.595.346-1 .984-1 1.723v5h1.277A1.984 1.984 0 0 1 20 21z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#23475F",
    d: "M22.957 60c1.812 2.618 4.459 6 6.043 6h38c2.209 0 3-.79 3-2.999"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#23475F",
    d: "M22.957 60c1.812 2.618 4.459 6 6.043 6h38c2.209 0 3-.79 3-2.999V60H22.957z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.d237e283c89a0f9fac1d3798669bc167.svg";
export { ForwardRef as ReactComponent };